<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header">
            <h4 class="pull-right">Добавить поля</h4>
          </header>
          <div class="card-body">
            <form class="w-100" autcomplete="off" @submit.prevent="fieldStore()">
              <div class="row">
                <div class="col-md-6">
                  <!-- <div class="form-group">
                    <label>name</label>
                    <input type="text" class="form-control" v-model="field.name" />
                  </div>-->
                  <div class="form-group">
                    <label>labelRus</label>
                    <input type="text" class="form-control" v-model="field.labelRus" autofocus />
                  </div>
                  <!--<div class="form-group">
                    <label>labelUzl</label>
                    <input type="text" class="form-control" v-model="field.labelUzl" />
                  </div>
                  <div class="form-group">
                    <label>labelUzk</label>
                    <input type="text" class="form-control" v-model="field.labelUzk" />
                  </div>-->
                  <div class="form-group">
                    <label>comment</label>
                    <input type="text" class="form-control" v-model="field.comment" />
                  </div>

                  <!-- <div class="form-group">
                    <label>fieldType (INPUT | SELECT)</label>
                    <input type="text" class="form-control" v-model="field.fieldType" />
                  </div>-->
                  <!-- <div class="form-group">
                    <label>fieldSize</label>
                    <input type="text" class="form-control" v-model="field.fieldSize" />
                  </div>-->
                  <div class="form-group">
                    <label>isRequired</label>
                    <select class="form-control" v-model="field.isRequired">
                      <option value="1">Да</option>
                      <option value="0">Нет</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>inputType (RADIO | CHECKBOX | TEXT | NUMBER)</label>
                    <select class="form-control" v-model="field.inputType">
                      <option value="0" disabled>Выберите тип</option>
                      <option
                        v-for="fieldType in fieldTypes"
                        :value="fieldType.value"
                        :key="fieldType.id"
                      >{{ fieldType.title }}</option>
                    </select>
                  </div>

                  <!-- ******** RANGEBLOCK ******** -->
                  <div id="RangeBlock" v-if="field.inputType == 'range'">
                    <div class="w-100 d-flex justify-content-sm-between">
                      <h2>RANGE</h2>
                    </div>

                    <div v-for="(row, index) in rangeRows" :key="index" :row="row">
                      <div class="row">
                        <div class="col-md-12 d-flex">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>От</label>
                              <input type="number" class="form-control" v-model="row.from" />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>До</label>
                              <div class="d-flex">
                                <input type="number" class="form-control" v-model="row.to" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- ******** RANGEBLOCK ******** -->

                  <!-- ******** CHECKBOXBLOCK ******** -->
                  <div id="CheckBoxBlock" v-if="field.inputType == 'checkbox'">
                    <div class="w-100 d-flex justify-content-sm-between">
                      <h2>CHECKBOX</h2>
                      <a class="btn btn-success cursor" @click="addRowCheckBox()">+</a>
                    </div>

                    <div v-for="(row, index) in checkboxRows" :key="index" :row="row">
                      <div class="row">
                        <div class="col-md-12 d-flex">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label>Значение</label>
                              <div class="d-flex">
                                <input type="text" class="form-control" v-model="row.value" />
                                <a
                                  class="btn btn-danger ml-2 cursor"
                                  @click="deleteRowCheckBox(index)"
                                >X</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- ******** CHECKBOXBLOCK ******** -->
                </div>
              </div>
              <div class="w-100 mr-10">
                <button type="submit" class="btn btn-primary pull-right mr-3">Добавить</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { GET, POST } from "../../shared/api";
export default {
  data() {
    return {
      field: {
        product_id: this.$route.params.product_id,
        inputType: 0,
        isRequired: 1,
        values: null
      },
      prepareFieldValues: [],
      checkboxRows: [{ value: "" }],
      rangeRows: [{ from: "", to: "" }],
      fieldTypes: [
        {
          id: 1,
          value: "range",
          title: "Диапазон"
        },
        {
          id: 2,
          value: "checkbox",
          title: "Несколько из нескольких (checkbox)"
        },
        {
          id: 3,
          value: "boolean",
          title: "Да Нет (Boolean)"
        }
      ]
    };
  },
  methods: {
    addRowCheckBox() {
      this.checkboxRows.push({ value: "" });
    },
    deleteRowCheckBox(index) {
      this.checkboxRows.splice(index, 1);
    },
    valuesSetDefault() {
      this.checkboxRows = [{ value: "" }];
      this.rangeRows = [{ from: "", to: "" }];
      this.field.values = null;
    },
    checkValues() {
      if (this.field.inputType === "range") {
        return JSON.stringify(this.rangeRows);
      }
      if (this.field.inputType === "checkbox") {
        for (var key in this.checkboxRows) {
          this.prepareFieldValues.push(this.checkboxRows[key]["value"]);
        }
        return JSON.stringify(this.prepareFieldValues);
      }
    },
    fieldStore() {
      this.field.values = this.checkValues();
      POST(this.field, "/field", this)
        .then(response => {
          this.valuesSetDefault();
          this.$router.push({
            name: "fieldsByProduct",
            params: { product_id: this.$route.params.product_id }
          });
        })
        .catch(error => {
          this.valuesSetDefault();
        });
    }
  },
  created() {},
  mounted() {
    let input = document.querySelector("[autofocus]");
    if (input) {
      input.focus();
    }
  }
};
</script>
